import React from 'react'

const EditReview = () => {
  return (
    <div>EditReview</div>
  )
}

export default EditReview